<template>
  <div v-cloak>
    <div class="container container-fluid bg--cardio">
      <div class="jumbotron" v-show="!closeJumbotron">
        <span class="top-right" @click="closeJumbo()">&times;</span>
        <h4>
          Du tittar just nu på <strong>Att göra</strong> sidan för kardiologpatienter i kardiologmodulen.
        </h4>
      </div>
      <div v-if="!cardioPatients">
        <vue-good-table :columns="[]" :rows="[]">
          <div class="text-left div-loader" slot="emptystate">
            Laddar patienter
          </div>
        </vue-good-table>
      </div>
      <div v-if="cardioPatients">
        <h1 class="pull-left text-muted">Att göra - {{noOfPatients}} patienter</h1>
        <div class="clearfix"></div>
        <vue-good-table
            :columns="columns" :rows="cardioPatients" :search-options="{
            enabled: true,
            placeholder: 'Sök',
          }" :sort-options="{
            enabled: true,
            initialSortBy: {field: 'statusChangeDate', type: 'desc'}
          }">
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'personId'">
              <router-link
                :to="{ name: 'patientcardio', params: { id: (props.row.personId) }}"
                v-if="props.row.personId && props.row.screeningStatus !== 19">
                {{ props.row.personId }}
              </router-link>
              <router-link
                :to="{ name: 'indexpatient', params: { id: (props.row.indexPatientId) }}"
                v-if="props.row.screeningStatus === 19 && (props.row.indexPatientId && props.row.indexPatientId !== -1)">
                {{ props.row.indexPatientId }}
              </router-link>
            </span>
            <span v-else-if="props.column.field == 'statusChangeDate'">
              <span v-if="props.row.statusChangeDate">{{ new Date(props.row.statusChangeDate).toLocaleDateString() }}</span>
              <span v-if="!props.row.statusChangeDate">-</span>
            </span>
            <span v-else-if="props.column.field == 'ssn'">
              <details>
                <summary>Personnummer</summary>
                {{ formatPnr(props.row.ssn) || '-' }}
              </details>
            </span>
            <span v-else-if="props.column.field == 'screeningStatus'">
              {{ getStatus(props.row.screeningStatus) || '-' }}
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
          <div slot="emptystate">
            Det finns inga kardiologpatienter som behöver hanteras just nu
          </div>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { getScreeningStatus } from '../plugins/screening_status'
import { request } from '../plugins/datocms'

export default {
  name: 'todocardio',
  components: {
  },
  data () {
    return {
      data: null,
      closeJumbotron: (localStorage.getItem('jumbotron-closed-todo') === 'true') || false,
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa',
      cardioPatients: null,
      countData: [],
      stats: [],
      columns: [
        {
          label: 'Inkommen',
          field: 'statusChangeDate',
          type: 'text'
        },
        {
          label: 'Patient#',
          field: 'personId',
          type: 'number'
        },
        {
          label: 'PNR',
          field: 'ssn',
          type: 'text'
        },
        {
          label: 'Efternamn',
          field: 'lastName',
          type: 'text'
        },
        {
          label: 'Förnamn',
          field: 'firstName',
          type: 'text'
        },
        {
          label: 'Status',
          field: 'screeningStatus',
          type: 'text',
          sortFn: this.sortStatus
        },
        {
          label: 'Registrerad av',
          field: 'clinician',
          type: 'text'
        },
        {
          label: 'Klinik',
          field: 'clinicName',
          type: 'text'
        }
      ]
    }
  },
  methods: {
    sortStatus (x, y, col, rowX, rowY) {
      const xRow = this.getStatus(rowX.screeningStatus)
      const yRow = this.getStatus(rowY.screeningStatus)
      return (xRow < yRow ? -1 : (xRow > yRow ? 1 : 0))
    },
    highlightMenu () {
      var $nav = $('#left-nav')
      var dur = 2000
      var originalColor = $nav.css('background')
      $nav.css('background', '#6D6F74')
      setTimeout(function () {
        $nav.css('background', originalColor)
      }, dur)
    },
    getStatus (status) {
      return getScreeningStatus(status)
    },
    closeJumbo () {
      localStorage.setItem('jumbotron-closed-todo', true)
      this.closeJumbotron = true
    },
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    formatPnr (ssn) {
      if (ssn) {
        const output = ssn.substring(0, 4) + '-' +
                      ssn.substring(4, 6) + '-' +
                      ssn.substring(6, 8) + '-' +
                      ssn.substring(8, 12)
        return output
      }
      return '-'
    },
    async getAllCardioPatients () {
      const screenStatusAll = 98
      axios._get(config.cardioUri + config.dashboardUri + '?ScreeningStatusType=' + screenStatusAll).then(response => {
        if (response) {
          this.cardioPatients = response.data.dashboardData
            ? response.data.dashboardData : []
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get all cardiopatients: ' + error)
        }
      })
    }
  },
  computed: {
    noOfPatients () {
      if (this.cardioPatients) {
        return this.cardioPatients.length
      }
      return 0
    }
  },
  created () {
    setTimeout(() => {
      $('.vgt-table').css('font-size', '14px')
    }, 1000)
  },
  async beforeMount () {
    await this.getAllCardioPatients()
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          faq {
            faqClinicText
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.pull-left {
  text-align: left;
}
.pointer {
  cursor: pointer;
}
.top-right {
  position: absolute;
  top: 0;
  right: 0;
  margin: 5px 15px 0px 0px;
  cursor: pointer;
  transform: scale(1.5);
}
.lh-1 {
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/TodoCardio.vue